import React from 'react';

interface SubmissionConfirmationProps {
    onBackToSchedule: () => void;
    displayText: string; // If you have a function to handle the "Back to schedule" action
}

const SubmissionConfirmation: React.FC<SubmissionConfirmationProps> = ({  onBackToSchedule, 
    displayText  }) => {
  return (
    <div className="min-h-[70%] mt-4 p-4 bg-white shadow-md rounded-lg">
      <h3 className="text-lg font-semibold mb-2">Meeting Scheduled Successfully!</h3>
      <p className="text-black-700 mb-4">{displayText}</p>
      <p className="text-black-600 mb-6">
        A calendar invitation and meeting link has been sent to your email address.
      </p>
    </div>
  );
};

export default SubmissionConfirmation;
